module.exports = __webpack_public_path__ + "img/inventory-bulk-update-button.b149c29e.png";